module.exports = __webpack_public_path__ + "static/media/login-bg-2.fa05617a.jpg";